export default __webpack_public_path__ + "static/Retail-Photo2-6d4598089afc2002ead811678be9e6a9.png";